import { NgIcon, provideIcons } from '@ng-icons/core';
import { matAutoAwesome } from '@ng-icons/material-icons/baseline';
import { Component } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InternalIcon } from '@shared/enums/internal-icon.enum';

@Component({
  selector: 'app-ai-indicator',
  templateUrl: './ai-indicator.component.html',
  imports: [NgIcon, NgbTooltipModule, TranslateModule],
  viewProviders: [provideIcons({ matAutoAwesome })],
})
export class AiIndicatorComponent {
  InternalIcon = InternalIcon;
  helplText = 'UI.AIExplanation';
}
